import Compressor from "compressorjs";
import moment from "moment";
import PAGE_CONSTANTS from "../Pages/Tracker/AppointmentBookingPage/constant";
import { medicalTestsConfiguration, AdditionalTestMapping } from "../Pages/Tracker/AppointmentBookingPage/medicalTestConfig";

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const getAdditionalTestArray = (testList) => {
  const newArr = [];
  AdditionalTestMapping?.forEach((obj) => {
    if(testList?.includes(obj?.name)){
        newArr?.push(obj?.name);
    }
  })
  return newArr;
}

export const getAdditionalSetList = (testList) => {
  const newArr = [];
  AdditionalTestMapping?.forEach((obj) => {
    if(testList?.includes(obj?.name)){
        newArr?.push(obj?.set);
    }
  })
  return newArr?.join();
}
export const getBase64_new = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const setSalutation = (title) => {
  if (title == "MS") {
    return "Ms.";
  } else if (title == "MRS") {
    return "Mrs.";
  } else if (title == "MR") {
    return "Mr.";
  } else {
    return "";
  }
};

export const fileCompress = async (file) => {
  return await new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.6,
      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

export const passwordPattern = () => {
  return [
    {
      required: true,
      message: "Password is required field.",
    },
    {
      min: 8,
      message: "Password must be at least 8 characters long.",
    },

    {
      pattern: new RegExp(/^(?=.*[a-z]).{0,}$/),
      message: "Password must have at least one lowercase ('a'-'z')",
    },
    {
      pattern: new RegExp(/^(?=.*[A-Z]).{0,}$/),
      message: "Password must have at least one uppercase ('A'-'Z')",
    },
    {
      pattern: new RegExp(/^(?=.*[0-9]).{0,}$/),
      message: "Password must have at least one digit ('0'-'9')",
    },
    {
      pattern: new RegExp(
        /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{0,}$/
      ),
      message:
        'Password must have at least one non alphanumeric character (" !"#$%&\'()*+,-./:;<=>?@[]^_`{|}~")',
    },
  ];
};

export const debounce = (fn, wait) => {
  let timeout;

  return function executedFunction(...args) {
    debugger;
    const later = () => {
      clearTimeout(timeout);
      fn(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export function dateIsValid(dateStr) {
  if (!dateStr) return
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  if (dateStr.match(regex) === null) {
    return false;
  }

  const [day, month, year] = dateStr.split('/');

  // 👇️ format Date string as `yyyy-mm-dd`
  const isoFormattedStr = `${year}-${month}-${day}`;

  const date = new Date(isoFormattedStr);

  const timestamp = date.getTime();

  if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
    return false;
  }

  return date.toISOString().startsWith(isoFormattedStr);
}

export function base64ToBlob(base64Data, contentType = "") {
  const byteCharacters = atob(base64Data);
  const byteArrays = []

  for (let offset = 0 ; offset < byteCharacters.length;offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumber = new Array(slice.length);
    for (let i=0; i < slice.length; i++){
      byteNumber[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumber)
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays,{type:contentType})
  return blob;
}
export const startLoader = () =>{
  if(!document.body.classList.contains("loading-indicator-api")){
    document.body.classList.add("loading-indicator-api");
  }
}
export const hideLoader = () =>{
  if(document.body.classList.contains("loading-indicator-api")){
    document.body.classList.remove("loading-indicator-api");
  }
}
export const getTokenTimestamp = () => {
  return moment().add(24, 'hours').unix() * 1000;
}
export const isNumberKey = (evt) => {
  if (/^[0-9]{1}$/.test(evt.key) || evt.key === "Backspace") {
    return true;
  } else {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
};

export const maskedEmail = (email) => {
  return email?.replace(
    /^(.)(.*)(.@.*)$/,
    (_, a, b, c) => a + b.replace(/./g, "*") + c
  );
};

export const maskPhoneNumber = (mobileNo) => {
  mobileNo = mobileNo?.toString();
  let maskNumber = "XXXXXX";
  const strMobStart = mobileNo?.slice(0, 2);
  const strMobEnd = mobileNo?.slice(8, 10);
  maskNumber = strMobStart + maskNumber + strMobEnd;
  return mobileNo ? maskNumber : "";
};

export const scrollToTop = (position = 0) => {
  window.scrollTo(0, position);
}

export const getVisitTypeByMedicalSet = (medicalTestList) => {
  const userTestName = medicalTestList?.toString()?.trim();
  const testObj = medicalTestsConfiguration?.find((testItem) => {
    const testName = testItem?.setName?.trim();
    if(userTestName === testName)
    {
      return testItem
    }
  })
  return testObj?.visitType || PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE
}

export const getAllowedMaxTimeByMedicalSet = (medicalTestList) => {
  const userTestName = medicalTestList?.toString()?.trim();
  const testObj = medicalTestsConfiguration?.find((testItem) => {
    const testName = testItem?.setName?.trim();
    if(userTestName === testName)
    {
      return testItem
    }
  })
  return testObj?.allowedMaxTime || PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM
}

export const convertTo24Hour = (hour, minute, modifier) => {
    // Convert to an integer
    let minutes = minute;
    let hours = parseInt(hour);
    // Convert 12 AM to 00
    if (modifier === 'AM' && hours === 12) {
        hours = 0;
    }
    // Convert 12 PM to 12 (no change needed)
    else if (modifier === 'PM' && hours !== 12) {
        hours += 12;
    }
    // Format hours and minutes to always have two digits
    hours = hours.toString().padStart(2, '0');
    minutes = minutes.padStart(2, '0');
    return `${hours}:${minutes}:00`;
}

export const getGender = (gender) => {
  switch(gender){
    case "MALE": 
    return "M";
    case "FEMALE":
    default:
      return "F";
  }
}

export const ruppeeConverter = (ruppee) => {
  if (!ruppee) return "0.00"
  ruppee = ruppee.toString().replace("-","")
  var newArr = ruppee.split(".")
  var strArr1 = ruppee.split(".")[0].split("")
  switch (newArr[0].length) {
    case 4:
    case 5:
      strArr1.splice(-3, 0, ",")
      newArr[0] = strArr1.join("")
      ruppee = newArr.join(".")
      break;
    case 6:
    case 7:
      strArr1.splice(-3, 0, ",")
      strArr1.splice(-6, 0, ",")
      newArr[0] = strArr1.join("")
      ruppee = newArr.join(".")
  }

  return ruppee
}

export const sanitizeFileName = (fileName) => {
  // Ensure the file name is a valid string
  if (typeof fileName !== 'string') {
    throw new Error('Invalid input: fileName must be a string.');
  }
  // Remove potentially harmful characters (e.g., directory traversal, null byte, etc.)
  // This regex allows only alphanumeric characters, dash, underscore, and periods (for file extensions).
  const sanitized = fileName.replace(/[^\w\-\.]/g, '');
  return sanitized;
};